(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ante-content-block-timeline"] && !Shopify.designMode) return;
  try {
    const supportsTimeline = window.CSS && CSS.supports && (CSS.supports("animation-timeline: scroll()") || CSS.supports("animation-timeline: --t"))

  const clamp = (value) => Math.min(1, Math.max(0, value))

  const localProgress = (p, a, b) => b === a ? (p * 100 >= a ? 1 : 0) : clamp((p * 100 - a) / (b - a))

  const parseRange = (value, fallback) => (value || fallback).split(" ").map(parseFloat)

  const dotStartOf = (container) => parseFloat(container.style.getPropertyValue("--timeline-dot-start")) || 24

  // Rest the dot at the bottom of the first tag by measuring its height (drives both the CSS and fallback paths).
  const measureDotStart = () => {
    for (const container of document.querySelectorAll(".content-block-timeline.timeline-style-2")) {
      for (const badge of container.querySelectorAll(".timeline-badge")) {
        if (badge.offsetHeight > 0) {
          container.style.setProperty("--timeline-dot-start", badge.offsetHeight + "px")
          break
        }
      }
    }
  }

  const update = () => {
    const viewport = window.innerHeight
    const lines = document.querySelectorAll(".content-block-timeline .timeline-line.timeline-line-progression")
    for (const line of lines) {
      const container = line.closest(".content-block-timeline")
      if (!container) continue

      const rect = line.getBoundingClientRect()
      const p = clamp((viewport - rect.top) / (viewport + rect.height))

      const mobile = container.clientWidth <= 500
      const lineRange = parseRange(mobile ? line.getAttribute("data-timeline-range-mobile") : line.getAttribute("data-timeline-range"), "10 60")
      const lineProgress = localProgress(p, lineRange[0], lineRange[1])

      if (container.classList.contains("timeline-style-2")) {
        const dotStart = dotStartOf(container)
        line.style.clipPath = "inset(0 0 calc((100% - " + dotStart + "px) * " + (1 - lineProgress) + ") 0)"
        const dot = container.querySelector(".timeline-dot")
        if (dot) dot.style.top = "calc(" + dotStart + "px + " + lineProgress + " * (100% - " + dotStart + "px))"
      } else {
        line.style.clipPath = "inset(0 0 " + ((1 - lineProgress) * 100) + "% 0)"
      }

      for (const badge of container.querySelectorAll(".timeline-badge.timeline-badge-progression")) {
        const range = parseRange(badge.getAttribute("data-timeline-range"), "10 18")
        badge.style.opacity = localProgress(p, range[0], range[1])
      }

      for (const fade of container.querySelectorAll(".timeline-fade")) {
        const range = parseRange(fade.getAttribute("data-timeline-range"), "10 18")
        fade.style.opacity = 0.4 + 0.6 * localProgress(p, range[0], range[1])
      }
    }
  }

  const onReady = () => {
    measureDotStart()
    window.addEventListener("resize", measureDotStart)

    if (!supportsTimeline) {
      update()
      window.addEventListener("scroll", update, { passive: true })
      window.addEventListener("resize", update)
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady)
  } else {
    onReady()
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ante-image"] && !Shopify.designMode) return;
  try {
    function destroyVideo(wrapper) {
    const video = wrapper?.querySelector("video")
    if (!video) return

    video.pause()
    video.removeAttribute("src")
    video.load()

    for (const source of video.querySelectorAll("source")) {
      source.remove()
    }

    video.srcObject = null
    wrapper.remove()
  }

  function removeInlineVideo(image) {
    destroyVideo(image._inlineVideo)
    image._inlineVideo = null
    image._inlineActive = false
    image.classList.remove("video-inlined")
  }

  function removeHoverVideo(image) {
    destroyVideo(image._video)
    image._video = null
    image._video_removed = true
    image.classList.remove("video-previewing")
  }

  document.addEventListener("mouseenter", e => {
    const image = e.target.closest?.(".ante-image")
    if (!image || image._inlineActive || image._video) return

    const modal = image.dataset.modal ?? image.dataset.video
    if (!modal) return

    image._video_removed = false
    image._video = document.createElement("div")
    image._video.classList.add("ante-image-video-preview")
    image._video.innerHTML = modal

    const video = image._video.querySelector("video")
    video.removeAttribute("controls")
    video.muted = true

    function onReady() {
      if (!image._video_removed && !image._inlineActive) {
        image.append(image._video)
        image.classList.add("video-previewing")
        video.play()
      }
    }

    if (video.readyState >= 2) onReady()
    else video.addEventListener("loadeddata", onReady, { once: true })
  }, true)

  document.addEventListener("mouseleave", e => {
    const image = e.target.closest?.(".ante-image")
    if (!image || image._inlineActive) return
    removeHoverVideo(image)
  }, true)

  document.addEventListener("click", e => {
    const image = e.target.closest?.(".ante-image")

    for (const el of document.querySelectorAll(".ante-image.video-inlined")) {
      if (el !== image) removeInlineVideo(el)
    }

    if (image && image.dataset.video) {
      if (image._inlineActive) return

      let resumeTime = 0
      let resume = false

      if (image._video) {
        const previewVideo = image._video.querySelector("video")
        if (previewVideo && Number.isFinite(previewVideo.currentTime) && previewVideo.currentTime > 0) {
          resumeTime = previewVideo.currentTime
          resume = true
        }
      }

      removeHoverVideo(image)

      image._inlineActive = true
      image._inlineVideo = document.createElement("div")
      image._inlineVideo.classList.add("ante-image-video-inline")
      image._inlineVideo.innerHTML = image.dataset.video

      const realVideo = image._inlineVideo.querySelector("video")
      realVideo.setAttribute("controls", "")

      if (resume) {
        function applyResume() {
          const duration = Number.isFinite(realVideo.duration) ? realVideo.duration : 0
          realVideo.currentTime = duration > 0 ? Math.min(resumeTime, Math.max(0, duration - 0.05)) : resumeTime
        }
        if (realVideo.readyState >= 1) applyResume()
        else realVideo.addEventListener("loadedmetadata", applyResume, { once: true })
      }

      image.append(image._inlineVideo)
      image.classList.add("video-inlined")
      realVideo.play()
    }
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ante-import-main"] && !Shopify.designMode) return;
  try {
    // Smooth scrolling

  window.getStickyTop = () => {
    const el = document.createElement("div")
    el.style.position = "fixed"
    el.style.top = "var(--sticky-top)"
    el.style.left = "0"
    el.style.width = "0"
    el.style.height = "0"
    el.style.pointerEvents = "none"
    el.style.visibility = "hidden"
    document.body.appendChild(el)
    const value = el.getBoundingClientRect().top
    el.remove()
    return value
  }

  function getElementTop(el) {
    let offset = 0
    if (el.classList.contains("ante-section")) {
      const child = el.firstElementChild
      if (child) {
        offset = parseFloat(getComputedStyle(child).paddingTop) || 0
      }
    } else if (el.classList.contains("ante-container")) {
      offset = parseFloat(getComputedStyle(el).paddingTop) || 0
    } else {
      if (Math.round(el.clientWidth) === document.documentElement.clientWidth) {
        offset = parseFloat(getComputedStyle(el).paddingTop) || 0
      }
    }

    let extra = 0
    let p = el.parentElement
    while (p) {
      if (getComputedStyle(p).position === "sticky" && p.parentElement) {
        const gap = p.parentElement.getBoundingClientRect().bottom - p.getBoundingClientRect().bottom
        if (gap > 0) extra += gap
      }
      p = p.parentElement
    }

    return el.getBoundingClientRect().top + window.scrollY - getStickyTop() + offset + extra
  }

  window.smoothScroll = (element, args = {}) => {
    let el = element

    while (el && getComputedStyle(el).display === "none") {
      el = el.nextElementSibling
    }

    if (!el) el = element

    if (args.lazy) {
      const rect = el.getBoundingClientRect()
      if (rect.top >= 0 && rect.top <= window.innerHeight) return
    }

    let attempts = 0
    let lastTop = null

    function scroll() {
      const top = getElementTop(el)
      if (lastTop !== null && Math.abs(top - lastTop) < 2) return
      lastTop = top

      window.scrollTo({ top, behavior: "smooth" })
      attempts++
      if (attempts < 4) setTimeout(scroll, 500)
    }

    scroll()
  }

  function handleHash(id) {
    const escaped = CSS.escape(id)
    const modalMatches = Array.from(document.querySelectorAll(`#modal-content-${escaped}`))
    if (modalMatches.length) {
      const modalContent = modalMatches[modalMatches.length - 1]
      showAnchorModal(JSON.parse(modalContent.textContent))
      return true
    }

    const target = document.querySelector(id.startsWith(".") || id.startsWith("[") ? id : `#${escaped}`)
    if (!target) return false

    smoothScroll(target)
    history.replaceState(null, "", window.location.pathname + window.location.search)
    return target
  }

  if (window.location.hash) {
    const hash = window.location.hash.slice(1)
    history.replaceState(null, "", window.location.pathname + window.location.search)
    window.scrollTo(0, 0)
    try { handleHash(hash) } catch (e) {}
  }

  document.body.addEventListener("click", e => {
    const link = e.target.closest("a[href*='#']")
    if (!link) return

    const href = link.getAttribute("href")
    const hashIndex = href.indexOf("#")
    if (hashIndex === -1) return
    const id = href.slice(hashIndex + 1)
    if (!id) return

    const before = href.slice(0, hashIndex)
    if (before && before !== window.location.pathname && before !== window.location.origin + window.location.pathname) return

    const target = handleHash(id)
    if (!target) return

    e.preventDefault()

    if (target !== true && "click" in link.dataset) {
      if (target.previousElementSibling?.type == "checkbox" && target.previousElementSibling?.checked) {
        return
      }
      target.click()
    }
  })

  // Show cart

  window.showCart = () => {
    if (window.SlideCart) SlideCart.load()
    else if (window.SLIDECART_OPEN) SLIDECART_OPEN()
    else window.location = "/cart"
  }

  // Add to cart

  const cartRoot = () => {
    const root = window.Shopify?.routes?.root || "/"
    return root.endsWith("/") ? root : `${root}/`
  }
  const cartPath = (path) => `${cartRoot()}${String(path).replace(/^\//, "")}`

  const parseCartError = async (r) => {
    const text = await r.text()
    try {
      const data = JSON.parse(text)
      return data.description || data.message || text || "Something went wrong. Please try again."
    } catch (_) {
      return text || "Something went wrong. Please try again."
    }
  }

  const addedItemsFrom = (payload) => {
    if (Array.isArray(payload)) return payload
    if (Array.isArray(payload?.items)) return payload.items
    return []
  }

  // Cart diagnostics. GTM is loaded site-wide but nothing pushed to it, so these used to
  // be console-only and therefore invisible in production. Push to dataLayer as well, and
  // keep the console line for local debugging.
  window.anteTrack = (event, detail = {}) => {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ event, ...detail })
    } catch (_) {}
    console.warn(event, detail)
  }

  const warnIfNestingFailed = (items, payload) => {
    const expected = new Set((items || []).filter(i => i.parent_id != null).map(i => String(i.id)))
    if (!expected.size) return
    const added = addedItemsFrom(payload)
    const nested = added.filter(item =>
      expected.has(String(item.id || item.variant_id)) && item.parent_relationship?.parent_key
    )
    if (nested.length < expected.size) {
      anteTrack("cart_nesting_failed", { expected: expected.size, nested: nested.length })
    }
  }

  // /cart/add.js can accept some lines and reject others — an out-of-stock or
  // market-restricted gift comes back as a short item list, not an error. Silent until now:
  // the international welcome-kit gap only surfaced by hand-reading orders.
  const warnIfItemsDropped = (items, payload) => {
    const requested = items || []
    if (requested.length < 2) return
    const received = new Set(addedItemsFrom(payload).map(i => String(i.id || i.variant_id)))
    if (!received.size) return
    const missing = requested.filter(i => !received.has(String(i.id))).map(i => String(i.id))
    if (missing.length) {
      anteTrack("cart_items_dropped", {
        requested: requested.length,
        received: received.size,
        missing: missing.join(","),
        tpl: window.anteTemplate || ""
      })
    }
  }

  window.addToCart = async ({ items, discount, clearCart, location: redirect }) => {
    const cartRedirect = !redirect || redirect === "/cart"
    const sectionIds = []
    if (cartRedirect && window.SlideCart?.sectionId) sectionIds.push(window.SlideCart.sectionId)

    try {
      if (cartRedirect && window.SlideCart) {
        SlideCart.show()
        SlideCart.showMessage(SlideCart.messages.adding)
      }

      if (clearCart) await fetch(cartPath("cart/clear.js"))

      if (discount) await fetch(cartPath("cart/update.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ discount: "" })
      })

      const addBody = { items }
      if (sectionIds.length) addBody.sections = sectionIds

      const addRequest = fetch(cartPath("cart/add.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(addBody)
      })

      // SlideCart applies the discount sequentially so it can show a message; without it there's no message, so fire the discount in parallel for actual speed.
      const discountRequest = discount && cartRedirect && !window.SlideCart
        ? fetch(cartPath(`discount/${encodeURIComponent(discount)}`))
        : null

      const [r] = await Promise.all([addRequest, discountRequest].filter(Boolean))

      if (!r.ok) {
        if (window.SlideCart) SlideCart.refresh()
        throw new Error(await parseCartError(r))
      }

      let payload = null
      try { payload = await r.json() } catch (_) {}

      warnIfNestingFailed(items, payload)
      warnIfItemsDropped(items, payload)

      if (discount && cartRedirect && window.SlideCart) {
        SlideCart.show()
        SlideCart.showMessage(SlideCart.messages.applyingDiscount)
        await fetch(cartPath(`discount/${encodeURIComponent(discount)}`))
      }

      document.dispatchEvent(new CustomEvent("cart:updated"))

      if (cartRedirect) {
        if (window.SlideCart) {
          SlideCart.show()
          // Always re-render from the live cart so automatic Discount API /
          // Function allocations are present. The add.js section snapshot can
          // land before those discounts are applied.
          SlideCart.refresh()
        } else if (window.SLIDECART_OPEN) {
          if (window.SLIDECART_UPDATE) SLIDECART_UPDATE(SLIDECART_OPEN)
          else SLIDECART_OPEN()
        } else {
          window.location = cartPath("cart")
        }
        return payload
      }

      window.location = discount
        ? `${cartPath("discount/" + encodeURIComponent(discount))}?redirect=${encodeURIComponent(redirect)}`
        : redirect
      return payload
    } catch (e) {
      if (e instanceof TypeError) throw new Error("Something went wrong. Please try again.")
      throw e
    }
  }

  // Add bundle to cart

  const BUNDLE_PRIME = 2147483647
  const BUNDLE_BASE = 31

  const bundleGcd = (a, b) => (b === 0 ? a : bundleGcd(b, a % b))

  const bundleId = (items) => {
    const g = items.map(i => i.quantity).reduce(bundleGcd)
    let sum = 0
    for (const i of items) {
      const q = Math.min(i.quantity / g, 9999)
      const s = `${i.id}${String(q).padStart(4, "0")}`
      let h = 0
      for (const d of s) {
        h = (h * BUNDLE_BASE + Number(d)) % BUNDLE_PRIME
      }
      sum = (sum + h) % BUNDLE_PRIME
    }
    return sum
  }

  window.stampCartBundle = (lines, { name = "Bundle", image } = {}) => {
    const totals = {}
    for (const l of lines) {
      totals[l.id] = (totals[l.id] || 0) + l.quantity
    }
    const magic = bundleId(Object.entries(totals).map(([id, quantity]) => ({ id, quantity })))
    const metaVariant = Object.keys(totals).reduce((a, b) => (Number(a) < Number(b) ? a : b))
    let metaAssigned = false
    return lines.map(l => {
      const isMeta = !metaAssigned && String(l.id) === String(metaVariant)
      if (isMeta) metaAssigned = true
      return {
        ...l,
        id: parseInt(l.id, 10),
        properties: {
          ...(l.properties || {}),
          _bundle: "true",
          _bundle_id: String(magic),
          ...(isMeta ? { _bundle_name: name, ...(image ? { _bundle_image: image } : {}) } : {})
        }
      }
    })
  }

  window.addBundleToCart = async (lines, { name = "Bundle", image, discount, clearCart, location } = {}) => {
    return addToCart({ items: stampCartBundle(lines, { name, image }), discount, clearCart, location })
  }

  window.addMembershipWithGifts = async ({
    items = [],
    giftIds = [],
    grouping = "nested",
    bundleName = "Welcome kit",
    bundleImage = "",
    rebuyProps = {},
    parentIsBundle = false,
    attachGifts = false,
    discount = "",
    clearCart = false,
    location
  } = {}) => {
    const lines = (items || []).filter(item => item && item.id)
    if (!lines.length) throw new Error("No product selected")

    const tpl = window.anteTemplate || ""
    if (tpl) {
      lines.forEach(item => {
        item.properties = { ...(item.properties || {}), _tpl: tpl }
        if (window.krxPdp07) item.properties._krx_pdp07 = window.krxPdp07
      })
    }

    const gifts = (giftIds || []).map(id => parseInt(id, 10)).filter(id => id > 1)
    const parent = lines.find(item => item.selling_plan) || lines[0]
    const parentVariantId = parseInt(parent?.id, 10)
    const useBundleId = grouping === "bundle" || grouping === "both"
    const useNested = grouping === "nested" || grouping === "both"
    const nestChildren = useNested && !parentIsBundle
    const shouldAttach = attachGifts && gifts.length && parentVariantId

    let finalGifts = gifts
    if (shouldAttach && !clearCart) {
      try {
        let cartItems = null
        if (window.SlideCart && window.SlideCart.state && window.SlideCart.state.items) {
          cartItems = window.SlideCart.state.items
        } else {
          const res = await fetch(cartPath("cart.js"))
          if (res.ok) {
            const data = await res.json()
            cartItems = data.items
          }
        }
        if (cartItems) {
          const existingIds = new Set(cartItems.map(i => String(i.id || i.variant_id)))
          const giftIdSet = new Set(gifts.map(id => String(id)))
          const hasKit = cartItems.some(i => giftIdSet.has(String(i.id || i.variant_id)))
          const hasSubscription = cartItems.some(i => i.selling_plan_allocation)
          // 1 free welcome kit / order — skip if cart already has a sub or kit lines
          if (hasKit || hasSubscription) {
            finalGifts = []
            anteTrack("welcome_kit_skipped", {
              reason: hasKit ? "kit_already_in_cart" : "subscription_already_in_cart",
              variantId: parentVariantId,
              tpl: window.anteTemplate || ""
            })
          } else {
            finalGifts = finalGifts.filter(id => !existingIds.has(String(id)))
          }
        }
      } catch (e) {
        console.warn("Failed to check existing gifts", e)
      }
    }

    const actuallyAttach = shouldAttach && finalGifts.length > 0

    if (actuallyAttach) {
      if (useNested && parentIsBundle) {
        anteTrack("welcome_kit_skipped", {
          reason: "parent_is_cart_transform_bundle",
          variantId: parentVariantId,
          gifts: finalGifts.length,
          grouping,
          tpl: window.anteTemplate || ""
        })
      }

      if (nestChildren || useBundleId) {
        finalGifts.forEach(id => {
          lines.push({
            id,
            quantity: 1,
            ...(nestChildren ? { parent_id: parentVariantId } : {}),
            properties: { ...rebuyProps }
          })
        })
      }
    }

    const cartOptions = { items: lines, discount, clearCart, location }

    // Stamp _bundle_id on gifts only (never Digestion / membership). Stamping
    // parent+gifts together made bundle "+" scale gifts and create paid
    // duplicates when Rebuy only frees one kit per order (ZN-1360).
    if (actuallyAttach && useBundleId && window.stampCartBundle) {
      const giftIdSet = new Set(finalGifts)
      const parentLines = lines.filter(l => !giftIdSet.has(parseInt(l.id, 10)))
      const giftLines = lines.filter(l => giftIdSet.has(parseInt(l.id, 10)))
      return addToCart({
        items: [
          ...parentLines,
          ...stampCartBundle(giftLines, { name: bundleName, image: bundleImage })
        ],
        discount,
        clearCart,
        location
      })
    }

    return addToCart(cartOptions)
  }

  // Newsletter

  if (location.search.includes("customer_posted=true") && location.hash === "#newsletter") {
    openModal("Signed up!", "Thanks for subscribing to our newsletter!")
    const url = new URL(location)
    url.searchParams.delete("customer_posted")
    history.replaceState(null, "", url.pathname + url.search)
  }

  // Cookie banner

  function modifyCookieBanner(banner) {
    banner.classList.add("ante-section")
    banner.style.fontFamily = "var(--font)"
    banner.style.padding = "var(--padding-medium)"
    banner.style.background = "var(--color-surface-background)"
    banner.style.boxShadow = "0 -4px 4px #0002"

    const wrapper = banner.querySelector(".shopify-pc__banner__wrapper")
    if (wrapper) {
      wrapper.style.columnGap = "var(--spacing-medium)"
      wrapper.style.rowGap = "var(--spacing-x-small)"
    }

    const body = banner.querySelector(".shopify-pc__banner__body")
    if (body) {
      body.style.margin = "0"
      body.style.display = "flex"
      body.style.flexDirection = "column"
      body.style.gap = "var(--micropad-small)"

      const message = body.querySelector(":scope > p:not(#shopify-pc__banner__body-title)")
      if (message) {
        const link = message.querySelector("a")
        const href = link ? link.getAttribute("href") : "/policies/privacy-policy"
        message.innerHTML = `We and our partners use cookies for personalization, advertising, and analytics, only with your consent. <a href="${href}">See our Privacy Policy</a>.`
      }

      body.querySelectorAll(":scope > p").forEach(p => p.classList.add("richtext"))
    }

    const title = banner.querySelector("#shopify-pc__banner__body-title")
    if (title) {
      const h4 = document.createElement("h4")
      h4.className = title.className
      h4.innerHTML = title.innerHTML
      title.replaceWith(h4)
    }

    const btns = banner.querySelector(".shopify-pc__banner__btns")
    const buttons = banner.querySelectorAll(".shopify-pc__banner__btns button")
    if (btns) btns.style.gap = "var(--micropad-medium)"
    buttons.forEach((btn, i) => {
      btn.className = "ante-button"
      btn.style.margin = "0"
      btn.style.setProperty("min-width", "0", "important")
      btn.style.setProperty("font-size", "var(--font-size-body)", "important")
      btn.style.setProperty("padding", "var(--micropad-x-large) var(--micropad-xxx-large)", "important")
      if (i === 0) btn.classList.add("secondary")
    })

    const gridQuery = matchMedia("(min-width: 1281px), (max-width: 480px)")
    const applyLayout = () => {
      if (btns) {
        btns.style.display = gridQuery.matches ? "grid" : "flex"
        btns.style.gridTemplateColumns = gridQuery.matches ? "1fr 1fr" : ""
      }
      buttons.forEach((btn, i) => {
        if (i === 0) {
          btn.style.order = gridQuery.matches ? "10" : ""
          btn.style.gridColumn = gridQuery.matches ? "1 / -1" : ""
        }
      })
    }
    applyLayout()
    gridQuery.addEventListener("change", applyLayout)
  }

  const cookieBannerObserver = new MutationObserver(() => {
    const banner = document.querySelector("#shopify-pc__banner, .shopify-pc__banner")
    if (banner && banner.querySelector(".shopify-pc__banner__btns button")) {
      cookieBannerObserver.disconnect()
      modifyCookieBanner(banner)
    }
  })
  cookieBannerObserver.observe(document.documentElement, { childList: true, subtree: true })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ante-import-modals"] && !Shopify.designMode) return;
  try {
    const modals = document.createElement("div")
  modals.id = "modals"
  if (window.anteModalColourTheme) {
    modals.classList.add(`color-theme-${window.anteModalColourTheme}`)
  }
  document.body.append(modals)

  function makeModal(title, content, id, args = {}) {
    const container = document.createElement("div")
    if (id) {
      container.id = id
    }
    container.classList.add("modal-container")
    if (args.type) {
      container.classList.add(`modal-type-${args.type}`)
    }
    container.setAttribute("tabindex", "-1")
    container.innerHTML = `
      <div class="modal-element">
        <div class="modal-title-row">
          <div class="modal-title">${title ?? "Modal"}</div>
          <button class="modal-close" aria-label="Close">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="modal-contents ante-section"></div>
      </div>
    `
    const contents = container.querySelector(".modal-contents")
    if (typeof content === "string") {
      contents.innerHTML = content
    } else {
      contents.append(...content.map(node => node.cloneNode(true)))
    }
    return container
  }

  function handleModal(modal, close, func) {
    modal.querySelector(".modal-title-row .modal-close").addEventListener("click", close)
    let down
    modal.addEventListener("mousedown", e => down = e.target)
    modal.addEventListener("mouseup", e => {
      if (down === e.target && e.target.classList.contains("modal-container")) {
        close()
      }
    })
    modal.addEventListener("keydown", e => {
      if (e.key === "Escape") {
        close()
      } else if (e.key === "Tab") {
        const focusable = modal.querySelectorAll(
          'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
        )
        if (!focusable.length) return
        const first = focusable[0]
        const last = focusable[focusable.length - 1]
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault()
          last.focus()
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault()
          first.focus()
        }
      }
    })
    if (modal.classList.contains("modal-type-slideout")) {
      const el = modal.querySelector(".modal-element")
      const header = modal.querySelector(".modal-title-row")
      const sheet = window.matchMedia("(max-width: 768px)")
      let startY = 0, delta = 0, lastY = 0, lastT = 0, velocity = 0, height = 0, dragging = false
      header.addEventListener("pointerdown", e => {
        if (!sheet.matches || e.button !== 0 || e.target.closest(".modal-close")) return
        dragging = true
        startY = lastY = e.clientY
        lastT = e.timeStamp
        delta = velocity = 0
        height = el.offsetHeight
        el.style.transition = "none"
        header.setPointerCapture(e.pointerId)
      })
      header.addEventListener("pointermove", e => {
        if (!dragging) return
        delta = Math.min(Math.max(0, e.clientY - startY), height)
        if (e.timeStamp > lastT) velocity = (e.clientY - lastY) / (e.timeStamp - lastT)
        lastY = e.clientY
        lastT = e.timeStamp
        el.style.transform = `translateY(${delta}px)`
      })
      function endDrag() {
        if (!dragging) return
        dragging = false
        el.style.transition = ""
        if (delta > height * 0.25 || velocity > 0.6) close()
        el.style.transform = ""
      }
      header.addEventListener("pointerup", endDrag)
      header.addEventListener("pointercancel", endDrag)
    }

    modals.append(modal)
    if (func) {
      modal.modalElement = modal.querySelector(".modal-element")
      modal.modalElement.close = close
      func(modal.modalElement)
    }
  }

  window.openModal = (title, content, id, func, args = {}) => {
    return new Promise(fulfil => {
      const modal = makeModal(title, content, id, args)
      modal.classList.add("opening")
      function close() {
        if (modal.modalElement?.locked) return
        modal.classList.remove("open")
        modal.classList.add("closing")
        const modalElement = modal.querySelector(".modal-element")
        modalElement.addEventListener("transitionend", function handler(e) {
          if (e.target !== modalElement) return
          modalElement.removeEventListener("transitionend", handler)
          modal.remove()
          const all = modals.querySelectorAll(".modal-container")
          if (all.length) {
            all[all.length - 1].focus()
          }
          fulfil()
        })
      }
      handleModal(modal, close, func)
      void modal.offsetWidth
      modal.classList.remove("opening")
      modal.classList.add("open")
      const focusable = modal.querySelectorAll(
        'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
      )
      if (focusable.length > 1) {
        focusable[1].focus()
      } else {
        modal.focus()
      }
    })
  }

  document.addEventListener("click", e => {
    const el = e.target.closest("[data-modal], .modal")
    if (!el) return

    if (el.hasAttribute("data-modal")) {
      openModal(
        el.dataset.modalTitle,
        el.dataset.modal,
        el.dataset.modalId,
        null,
        el.dataset.modalType
      )
      return
    }

    const modals = document.querySelectorAll(".modal")
    for (const modal of modals) {
      if (!modal.dataset.trigger) continue
      if (e.target.closest("." + modal.dataset.trigger)) {
        if (!modal._modalData) {
          modal._modalData = {
            title: modal.dataset.title,
            content: [...modal.children],
            id: modal.dataset.modalId ?? modal.dataset.trigger + "-modal",
            type: modal.dataset.modalType
          }
        }

        const d = modal._modalData
        openModal(d.title, d.content, d.id, null, d.type)
        return
      }
    }
  })

  function showAnchorModal(data) {
    history.replaceState(null, "", location.pathname + location.search)
    let style = "<style>"
    if (data.width > 0) {
      style += `.modal-contents { width: clamp(var(--modal-min-width), var(--width-${data.width}), var(--modal-max-width)); }\n`
      style += `@media (max-width: 1440px) { .modal-contents { width: clamp(var(--modal-min-width), var(--width-${data.widthSmallDesktop}), var(--modal-max-width)); } }\n`
      style += `@media (max-width: 1024px) { .modal-contents { width: clamp(var(--modal-min-width), var(--width-${data.widthTablet}), var(--modal-max-width)); } }\n`
      style += `@media (max-width: 600px) { .modal-contents { width: clamp(var(--modal-min-width), var(--width-${data.widthMobile}), var(--modal-max-width)); } }\n`
    }
    let content = ""
    const id = data.contentType === "video" ? "video-modal" : "modal-" + Math.random().toString(16).replace("0.", "")
    if (data.contentType === "with_image") {
      content += `
        <div class="modal-with-image-top">
          <div class="richtext">${data.content.imageContent}</div>
          ${data.content.image ? `<img src="${data.content.image}">` : ""}
        </div>
        ${data.content.secondaryContent ? `<div class="richtext">${data.content.secondaryContent}</div>` : ""}
      `
      style += `
        .richtext .modal-with-image-top {
          display: flex !important;
          flex-direction: row;
          gap: var(--spacing-medium);
          align-items: center;
        }

        .modal-with-image-top:nth-last-child(3) {
          margin-bottom: var(--spacing-small);
        }

        .modal-with-image-top:first-child {
          flex: 1;
          align-self: flex-start;
        }

        .modal-with-image-top img {
          max-width: min(100%, ${data.content.imageWidth}px);
        }

        @media (max-width: 600px) {
          .modal-with-image-top {
            flex-direction: column !important;
            align-items: flex-start;
          }

          .modal-with-image-top img {
            align-self: center;
          }
        }
      `
    } else if (data.contentType === "iframe") {
      content += `<iframe src="${data.content.iframeURL}"></iframe>`
      style += `
        #${id} .modal-contents {
          padding: 0;
        }
        
        #${id} iframe {
          display: block;
          border: none;
          width: 100%;
          height: var(--modal-max-height);
        }
      `
    } else if (data.contentType === "images") {
      content += data.content.images.map(e => `<img src="${e}">`).join("")
    } else if (data.contentType === "video") {
      content += `<video controls playsinline src="${data.content.video}"${data.content.autoplay ? " autoplay" : ""}></video>`
    } else {
      content += data.content.content
    }
    style += "</style>"
    if (style !== "<style></style>") {
      content += style
    }
    openModal(data.content.title, `<div class="richtext">${content}</div>`, id, null, data)
  }
  window.showAnchorModal = showAnchorModal
  } catch(e) { console.error(e); }
})();

})();
